import { TOGGLE_QA_ARTICLE } from '../reducers/faq';

export const toggleQaArticle = (placeAlias: string, articleId: string) => {
    return {
        type: TOGGLE_QA_ARTICLE,
        payload: {
            placeAlias,
            articleId,
        },
    };
};
